var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCastro = function SvgCastro(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.313 0h19.374c6.425 0 9.637 0 13.096 1.094a13.593 13.593 0 0 1 8.124 8.124C64 12.676 64 15.888 64 22.313v19.374c0 6.425 0 9.637-1.093 13.096a13.593 13.593 0 0 1-8.124 8.124C51.324 64 48.112 64 41.687 64H22.313c-6.425 0-9.637 0-13.095-1.093a13.593 13.593 0 0 1-8.124-8.124C0 51.324 0 48.112 0 41.687V22.313c0-6.425 0-9.637 1.093-13.095a13.593 13.593 0 0 1 8.125-8.124C12.676 0 15.888 0 22.313 0Z",
    fill: "url(#Castro_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.031 4.188c15.378 0 27.844 12.453 27.844 27.816S47.41 59.821 32.031 59.821c-15.377 0-27.843-12.454-27.843-27.817S16.654 4.188 32.03 4.188Z",
    fill: "url(#Castro_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.617 47.867-4.669-6.469a11.764 11.764 0 0 0 4.837-9.515c0-6.509-5.282-11.785-11.797-11.785-6.515 0-11.797 5.276-11.797 11.785 0 3.925 1.922 7.401 4.876 9.543L20.395 47.9c-4.967-3.59-8.198-9.429-8.198-16.021 0-10.917 8.858-19.767 19.786-19.767 10.927 0 19.786 8.85 19.786 19.767 0 6.572-3.212 12.394-8.152 15.988ZM32.027 27.11c2.629 0 4.76 2.129 4.76 4.755a4.758 4.758 0 0 1-4.76 4.755 4.758 4.758 0 0 1-4.76-4.755 4.758 4.758 0 0 1 4.76-4.755Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Castro_svg__a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Castro_svg__b",
    x1: 4.188,
    y1: 4.188,
    x2: 4.188,
    y2: 59.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCastro);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "32b81be16e5f82b68e7034ec2c342466.svg";